// eslint-disable-next-line no-restricted-imports
import {
  QueryInput_OperationController_GetOrders_OwnerType,
  useOperationGetOrdersQuery,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { parseOperationOrderEntity } from 'api/helpers/operation';
import { ListData, ListDataQueryFunction } from 'api/types/data';
import { PrimaryClientType } from 'api/types/entity';
import { OperationOrderEntity } from 'api/types/entity/operation';
import { lodash } from 'helpers';

export const useOperationOrders: ListDataQueryFunction<
  OperationOrderEntity,
  {
    search?: string;
  },
  '',
  { clientType: PrimaryClientType; clientId: string }
> = ({ pagination, filter, params }) => {
  const {
    loading,
    error: serverError,
    data,
  } = useOperationGetOrdersQuery({
    variables: {
      limit: pagination.limit,
      ownerType:
        QueryInput_OperationController_GetOrders_OwnerType[params.clientType],
      ownerId: params.clientId,
      page: pagination.page + 1,
      search: filter?.search?.toString() || undefined,
    },
    fetchPolicy: 'no-cache',
  });

  const error = useError(serverError);

  const listData: ListData<OperationOrderEntity> | undefined = data?.orders
    ? {
        total: data?.orders.total,
        list: lodash.compact(data?.orders.list).map(parseOperationOrderEntity),
      }
    : undefined;

  return {
    listData,
    loading,
    error,
  };
};
